module.exports = __webpack_public_path__ + "static/media/albaraka_api.aefbdda0.jpg";